import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { SunHorizon } from './graphics/Glyphs';
const words = ['urage', 'nnection', 'mmunity', 'uriosity', 'ulture', 'nfidence', 'mpassion'];
function useTypewriter() {
  const [index, setIndex] = useState(0);
  const [text, setText] = useState('');
  const [deleting, setDeleting] = useState(false);
  useEffect(() => {
    const current = words[index];
    const speed = deleting ? 50 : 100;
    const t = setTimeout(() => {
      if (!deleting) {
        const next = current.slice(0, text.length + 1);
        setText(next);
        if (next === current) setTimeout(() => setDeleting(true), 1800);
      } else {
        const next = current.slice(0, text.length - 1);
        setText(next);
        if (next === '') {
          setDeleting(false);
          setIndex(i => (i + 1) % words.length);
        }
      }
    }, speed);
    return () => clearTimeout(t);
  }, [text, deleting, index]);
  return text;
}
export function Hero() {
  const word = useTypewriter();
  return <section id="top" className="relative min-h-screen flex flex-col bg-paper overflow-hidden" data-id="element-86">
      {/* Background sun — much softer */}
      <div className="absolute inset-0 flex items-end justify-center pointer-events-none" data-id="element-87">
        <div className="w-[110%] md:w-[70%] aspect-[2/1] text-sun/15 -mb-[12%]" data-id="element-88">
          <SunHorizon className="w-full h-full" data-id="element-89" />
        </div>
      </div>

      <div className="relative flex-1 flex items-center pt-32 pb-24 px-6 md:px-12" data-id="element-90">
        <div className="max-w-5xl mx-auto w-full text-center" data-id="element-91">
          <motion.p initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 1,
          delay: 0.3
        }} className="eyebrow mb-10" data-id="element-92">
            An Invitation — 2027
          </motion.p>

          <motion.h1 initial={{
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 1.2,
          delay: 0.5
        }} className="font-serif-display text-[56px] sm:text-[90px] md:text-[120px] lg:text-[160px] leading-[0.92] text-ink" data-id="element-93">
            <span className="inline-flex items-baseline" data-id="element-94">
              Co
              <span className="italic text-sun" data-id="element-95">.</span>
              <span className="italic text-ink/75" data-id="element-96">
                {word}
                <span className="typing-cursor h-[0.65em]" data-id="element-97"></span>
              </span>
            </span>
          </motion.h1>

          {/* animated divider line */}
          <motion.div initial={{
          scaleY: 0
        }} animate={{
          scaleY: 1
        }} transition={{
          duration: 1.4,
          delay: 1.4,
          ease: [0.65, 0, 0.35, 1]
        }} style={{
          transformOrigin: 'top'
        }} className="mx-auto mt-14 w-px h-12 bg-ink/30" data-id="element-98" />

          <motion.p initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 1,
          delay: 2
        }} className="mt-8 font-serif-display italic text-ink/65 text-base md:text-lg max-w-md mx-auto leading-relaxed" data-id="element-99">
            A small-group travel house for women. <br data-id="element-100" />
            Come as you are. Leave changed.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 8
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 1,
          delay: 2.3
        }} className="mt-12" data-id="element-101">
            <a href="#waitlist" className="inline-flex items-center justify-center px-10 py-4 bg-ink text-bone text-[11px] uppercase tracking-[0.32em] hover:bg-sun transition-colors duration-500" data-id="element-102">
              Request an Invitation
            </a>
            <p className="mt-6 eyebrow !text-muted" data-id="element-103">
              Costa Rica · Mexico · Portugal
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}